module.exports = __webpack_public_path__ + "img/lottery-3.e8fc4b5e.svg";